@if (statistics.careRecipientTabResultMsg) {
  <div class="alert alert-success" role="alert" id="messageBoard" [@fadeOut]>
    {{ statistics.careRecipientTabResultMsg | translate }}
  </div>
}

@if (statistics.careRecipientCardsLoaded) {
  <div cdkDropListGroup>
    @for (row of cardRows; track row; let i = $index; let last = $last) {
      <div
        class="cardRow"
        cdkDropList
        cdkDropListOrientation="horizontal"
        [cdkDropListData]="{ rowIndex: i, item: row }"
        (cdkDropListDropped)="onCardDrop($event)"
        [ngClass]="{ lastRow: !cardsCountEvenToThree && last }"
        >
        @for (card of row; track card; let i = $index) {
          <care-recipient-card
            [careRecipientStats]="card"
            [translations]="translations"
            [longestAvgWaitTime]="longestAvgWaitTime"
            [longestAvgCareTime]="longestAvgCareTime"
            (cdkDragStarted)="isCardDragged = true"
            (cdkDragEnded)="isCardDragged = false"
            cdkDrag
          ></care-recipient-card>
        }
        @if (!cardsCountEvenToThree && last) {
          <div
            class="newCareRecipient"
            style="margin-left: 15px"
            (click)="openNewCareRecipientCardDialog()"
            >
            <h5>+ {{ "ADD_NEW" | translate }}</h5>
          </div>
        }
      </div>
    }
    @if (cardsCountEvenToThree) {
      <div class="cardRow lastRow">
        <div
          class="newCareRecipient"
          (click)="openNewCareRecipientCardDialog()"
          >
          <h5>+ {{ "ADD_NEW" | translate }}</h5>
        </div>
      </div>
    }
  </div>
} @else {
  <img
    class="fadeLoader centerLoader logoSmall"
    src="assets/img/loading_logo.svg"
    />
  }

